"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _StyledSectionTitle = require("../StyledSectionTitle");

var StyledButton = (0, _material.styled)('button')({});
var styles = {
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    pb: 1
  },
  toggleButton: {
    m: 0,
    p: 0,
    background: 'transparent',
    border: 'none',
    width: '100%',
    cursor: 'pointer'
  },
  chevronIcon: {
    mx: 1,
    transition: 'transform .25s ease-out',
    transform: 'rotate(0deg)'
  },
  chevronIconActive: {
    transform: 'rotate(90deg)'
  }
};

var CollapsibleSectionTitle = function CollapsibleSectionTitle(_ref) {
  var title = _ref.title,
      _ref$in = _ref.in,
      isOpen = _ref$in === void 0 ? false : _ref$in,
      children = _ref.children,
      boxProps = (0, _objectWithoutProperties2.default)(_ref, ["title", "in", "children"]);

  var _useState = (0, _react.useState)(isOpen),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    setOpen(isOpen);
  }, [isOpen]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, boxProps, /*#__PURE__*/_react.default.createElement(StyledButton, {
    sx: styles.toggleButton,
    type: "button",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react.default.createElement(_StyledSectionTitle.StyledSectionTitle, {
    sx: styles.title
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    sx: [styles.chevronIcon, open && styles.chevronIconActive],
    icon: "chevron-right"
  }), " ", title)), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: open
  }, children));
};

var _default = CollapsibleSectionTitle;
exports.default = _default;